export const MENU_ITEMS = [
  {
    label: "About Us",
    key: "about",
    children: [
      {
        label: "About 5ire",
        key: "about_5ire",
      },
      {
        label: "Team",
        key: "team",
      },
      {
        label: "Blog",
        key: "blog",
      },
      {
        label: "Road to Mainnet",
        key: "road_to_mainnet",
      },
      {
        label: "News & Media",
        key: "news_and_media",
      },
     
    ],
  },
  {
    label: "Testnet",
    key: "testnet",
    children: [
      {
        label: "Testnet",
        key: "test_net",
      },
      {
        label: "Build To Earn",
        key: "build_to_earn",
      },
      {
        label: "Documentation",
        key: "documentation",
      },
    ],
  },
  {
    label: "Community",
    key: "community",
    children: [
      {
        label: "Community",
        key: "commmunity",
      },
      {
        label: "5ire Ambassador",
        key: "5ire_ambassador",
      },
      {
        label: "Partner With Us",
        key: "partner_with_us",
      },
    ],
  },

  {
    label: "Research",
    key: "research",
    children: [
      {
        label: "Research Papers",
        key: "research_papers",
      },
      {
        label: "Yellow Paper",
        key: "yellow_paper",
      },
      {
        label: "White Paper",
        key: "white_paper",
      },
    ],
  },
  {
    label: "Validator",
    key: "validator",
    children: [
      {
        label: "Become a Validator",
        key: "become_a_validator",
      },
    ],
  },
  {
    label: "Sustainabliity",
    key: "sustainabliity",
  },
 
  
];
